import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { stringify } from 'hub-http/helpers/params';
export const FLOW_REVISION_BY_ID_FIELDNAME = 'automation_ui_management_flowRevisionById';
export const GET_FLOW_REVISION_BY_ID = registerQuery({
  fieldName: FLOW_REVISION_BY_ID_FIELDNAME,
  args: ['flowId', 'revisionId'],
  fetcher({
    flowId,
    revisionId
  }) {
    return http.get(`automationplatform/v1/hybrid/revisions/${flowId}/${revisionId}`);
  }
});
export const FLOW_REVISIONS_FIELDNAME = 'automation_ui_management_flowRevisions';
export const GET_FLOW_REVISIONS = registerQuery({
  fieldName: FLOW_REVISIONS_FIELDNAME,
  args: ['flowId', 'userId', 'timestamp', 'cutoffTime', 'after', 'limit', 'includeAssociatedBulkEnrollments'],
  fetcher({
    flowId,
    userId,
    timestamp,
    cutoffTime,
    after,
    limit = 50,
    includeAssociatedBulkEnrollments = true
  }) {
    const params = {
      after,
      cutoffTime,
      limit,
      timestamp,
      userId,
      includeAssociatedBulkEnrollments
    };
    return http.get(`automationplatform/v1/hybrid/revisions/${flowId}?${stringify(params)}`);
  }
});
export const GET_FLOW_REVISIONS_FIELD_POLICY = {
  keyArgs: ['flowId', 'userId', 'timestamp', 'cutoffTime'],
  merge(existing, incoming) {
    if (!existing) {
      return incoming;
    }
    return Object.assign({}, incoming, {
      results: [...existing.results, ...incoming.results]
    });
  }
};
export const FLOW_REVISIONS_RANGE_FIELDNAME = 'automation_ui_management_flowRevisionsRange';
export const GET_FLOW_REVISIONS_WITHIN_TIMESTAMP_RANGE = registerQuery({
  fieldName: FLOW_REVISIONS_RANGE_FIELDNAME,
  args: ['flowId', 'timestampMin', 'timestampMax'],
  fetcher({
    flowId,
    timestampMin,
    timestampMax
  }) {
    return http.get(`automationplatform/v1/hybrid/revisions/${flowId}?cutoffTime=${timestampMin}&timestamp=${timestampMax}`).then(({
      results
    }) => results);
  }
});